import * as Sentry from '@sentry/astro'

import config from './config/env.json' assert { type: 'json' }
import { environment } from './src/server/env'

Sentry.init({
  dsn: config.sentryDSN,
  environment,
  release: import.meta.env.PUBLIC_RELEASE,
  integrations: [
    Sentry.thirdPartyErrorFilterIntegration({
      filterKeys: ['broadband-frontend-sentry-application-key'],
      behaviour: 'drop-error-if-contains-third-party-frames'
    })
  ],
  ignoreErrors: ['Network request failed', 'Failed to fetch', 'NetworkError'],
  tracesSampleRate: 0.2,
  // Sample rate for how often the *entire* session should be recorded start to finish.
  replaysSessionSampleRate: 0,
  // Sample rate for when there is an error, how often the relevant part of the session should be recorded.
  // Records up to 1 minute before the error, and until the end of the session after the error.
  replaysOnErrorSampleRate: 0.5
})
